export const DATA = [
	{
		group: "a",
		items: [
			{
				id: 1,
				name: "Andre Allison",
				img: "3",
				email: "andre-allison@allison.hn",
				phone: "303-570-0941",
				job: "Investor Implementation Analyst",
				company: "Harvey Inc",
				address: "866 Romrog Way, Curtis, 69025, Nebraska",
				notes:
					"Nulla vitae elit libero, a pharetra augue. " +
					"Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. " +
					"Vestibulum id ligula porta felis euismod semper. Nullam quis risus eget urna mollis ornare vel eu leo. " +
					"Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus.",
				favourite: true,
			},
			{
				id: 2,
				name: "Allion Murphy",
				img: "4",
				email: "allion-murphy@aool.com",
				phone: "212-692-6590",
				job: "Social Media Manager",
				company: "Voot and Voxy Inc.",
				address: "516  Oakwood Avenue, 10016, New York",
				notes: "Aenean lacinia bibendum nulla sed consectetur. Nulla vitae elit libero a pharetra augue.",
				favourite: true,
			},
			{
				id: 3,
				name: "Ann Skinner",
				cap: "d",
				color: "bg-warning",
				border: "border-warning",
				email: "ann-skinner@shotmail.com",
				phone: "270-787-1629",
				job: "Freelance Graphics Designer",
				company: "Self Employed",
				address: "509  Coffman Alley, Paducah, Kentucky",
				notes: "",
				favourite: false,
			},
		],
	},
	{
		group: "b",
		items: [
			{
				id: 4,
				name: "Brandon Leonard",
				cap: "B",
				color: "bg-teal",
				border: "border-teal",
				email: "brandon-leonard@aahoo.com",
				phone: "740-310-9627",
				job: "Product Intranet Manager",
				company: "Anderson-Veum",
				address: "3221 Margaret Street, Houston, Texas",
				notes:
					"Nullam quis risus eget urna mollis ornare vel eu leo. " +
					"Maecenas sed diam eget risus varius blandit sit amet non magna. " +
					"Praesent commodo cursus magna, vel scelerisque nisl consectetur et. " +
					"Morbi leo risus, porta ac consectetur ac, vestibulum at eros.",
				favourite: false,
			},
			{
				id: 5,
				name: "Boris Ramirez",
				img: "16",
				email: "boris-ramiraz@aahoo.com",
				phone: "315-338-3921",
				job: "Chief Technology Officer",
				company: "Manco Software Solutions",
				address: "338  Oak Street, Rome, New York",
				notes: "Donec id elit non mi porta gravida at eget metus.",
				favourite: false,
			},
		],
	},
	{
		group: "c",
		items: [
			{
				id: 6,
				name: "Carmen Erickson",
				img: "12",
				email: "carmen-erickson@aool.com",
				phone: "412-305-8581",
				job: "Corporate Mobility Orchestrator",
				company: "Mraz, Senger and Gislason",
				address: "1579 Coal Road, Sugar Notch, 18706, Pennsylvania",
				notes: "",
				favourite: false,
			},
			{
				id: 7,
				name: "Carroll Hunt",
				img: "14",
				email: "carroll-hunt@hunt.hn",
				phone: "713-919-6065",
				job: "District Directives Agent",
				company: "Turcotte, Murphy and Kreiger",
				address: "4020 Margaret Street, Houston, Texas",
				notes: "",
				favourite: true,
			},
		],
	},
	{
		group: "e",
		items: [
			{
				id: 8,
				name: "Ellen Boone",
				cap: "E",
				color: "bg-primary",
				border: "border-primary",
				email: "ellen-boone@amail.com",
				phone: "720-231-6682",
				job: "Direct Marketing Specialist",
				company: "Huels, Runte and Klocko",
				address: "27 Cinnamon Lane, San Antonio, Texas",
				notes:
					"Donec ullamcorper nulla non metus auctor fringilla. " +
					"Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. " +
					"Vestibulum id ligula porta felis euismod semper. Nullam quis risus eget urna mollis ornare vel eu leo.",
				favourite: true,
			},
			{
				id: 9,
				char: "E",
				name: "Elbert Elliott",
				img: "13",
				email: "elbert-elliott@liive.com",
				phone: "859-967-9374",
				job: "Research Specialist",
				company: "Flatley-Jacobson",
				address: "4694 Counts Lane, Lexington, Kentucky",
				notes: "",
				favourite: false,
			},
			{
				id: 10,
				name: "Emanuel Owens",
				cap: "E",
				color: "bg-info",
				border: "border-info",
				email: "emanuel-owens@hiive.com",
				phone: "808-728-0871",
				job: "District Directives Agent",
				company: "Jenkins Inc",
				address: "1421 Indiana Avenue, Honolulu, 96814, Hawaii",
				notes: "Maecenas sed diam eget risus varius blandit sit amet non magna.",
				favourite: false,
			},
		],
	},
	{
		group: "f",
		items: [
			{
				id: 11,
				char: "F",
				name: "Faith Alexander",
				cap: "F",
				color: "bg-danger",
				border: "border-danger",
				email: "faith-alexander@houtlook.com",
				phone: "740-310-9627",
				job: "Identity Supervisor",
				company: "Ward, Zemlak and Gutkowski",
				address: "3376 Lowes Alley, Saint Clairsville, 43950, ",
				notes: "Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.",
				favourite: true,
			},
		],
	},
	{
		group: "j",
		items: [
			{
				id: 12,
				name: "Joan Hernandez",
				cap: "J",
				color: "bg-success",
				border: "border-success",
				email: "joan-hernandez@mails.com",
				phone: "703-380-2084",
				job: "International Quality Associate",
				company: "Grimes, Krajcik and Jerde",
				address: "3190 Maxwell Farm Road, Roanoke, 24011, Virginia",
				notes: "Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.",
				favourite: true,
			},
		],
	},
	{
		group: "m",
		items: [
			{
				id: 13,
				name: "Marsha Swanson",
				img: "10",
				email: "marsha-swanson@swann.com.hn",
				phone: "512-284-2226",
				job: "District Directives Agent",
				company: "Towne Ltd",
				address: "4687 Sundown Lane, Bastrop, 78701, Texas",
				notes: "",
				favourite: false,
			},
		],
	},
	{
		group: "n",
		items: [
			{
				id: 14,
				name: "Nadine Guerrero",
				img: "1",
				email: "nadine-guerrero@aool.com",
				phone: "540-257-7385",
				job: "Investor Applications Producer",
				company: "Bechtelar Ltd",
				address: "2542 West Street, Grand Rapids, Michigan",
				notes:
					"Cras justo odio, dapibus ac facilisis in, egestas eget quam. " +
					"Donec ullamcorper nulla non metus auctor fringilla. Maecenas sed diam eget risus varius blandit sit amet non magna. " +
					"tiam porta sem malesuada magna mollis euismod. Nullam id dolor id nibh ultricies vehicula ut id elit. Aenean eu leo quam. " +
					"Pellentesque ornare sem lacinia quam venenatis vestibulum.",
				favourite: false,
			},
			{
				id: 15,
				name: "Natasha Mckenzie",
				cap: "N",
				color: "bg-purple",
				border: "border-purple",
				email: "natasha-mckenzie@benn.ln",
				phone: "806-275-8406",
				job: "Mobility Specialist",
				company: "Kemmer and Sons",
				address: "3054 Hilltop Drive, Borger, Texas",
				notes: "Cras mattis consectetur purus sit amet fermentum.",
				favourite: false,
			},
		],
	},
	{
		group: "r",
		items: [
			{
				id: 16,
				name: "Rodney Harrison",
				img: "11",
				email: "rodney-harrison@rodd.com",
				phone: "202-253-4772",
				job: "Regional Communications Executive",
				company: "Bahringer LLC",
				address: "2606 Passaic Street, Adelphi, 20783, Washington DC",
				notes:
					"Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. " +
					"Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Aenean eu leo quam. " +
					"Pellentesque ornare sem lacinia quam venenatis vestibulum. Curabitur blandit tempus porttitor. " +
					"Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. " +
					"Nullam id dolor id nibh ultricies vehicula ut id elit.",
				favourite: false,
			},
		],
	},
	{
		group: "s",
		items: [
			{
				id: 17,
				name: "Santos Underwood",
				img: "15",
				email: "santos-underwood@santos.sn",
				phone: "314-399-4896",
				job: "Corporate Mobility Orchestrator",
				company: "Okuneva Group",
				address: "1386 Bruce Street, Saint Louis, Missouri",
				notes: "",
				favourite: false,
			},
			{
				id: 18,
				name: "Salvador Flowers",
				cap: "S",
				color: "bg-pink",
				border: "border-pink",
				email: "salvador-flowers@salv.fl",
				phone: "419-283-5041",
				job: "Senior Applications Architect",
				company: "Smith-Runolfsdottir",
				address: "724 Cedarstone Drive, Toledo, 43613, Ohio",
				notes: "Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.",
				favourite: true,
			},
		],
	},
];
